<template>
  <section class="step3" ref="message-review">
    <div class="col-sm-12">
      <div class="row justify-content-center">
        <div :class="isEmailTemplate ? 'col-md-4' : 'col-md-6'">
          <div v-if="isEmailWrite" class="form-group mt-2">
            <label>{{ __('message_interface.step3.subject') }}</label>
            <input type="text" class="form-control" v-model="message.messageSubject" />
          </div>
          <div class="form-group mt-2">
            <label>{{ __('message_interface.step3.your_msg') }}</label>
            <p v-if="message.model === 'model'">
              {{ __('message_interface.step3.msg_sub_title') }}
            </p>
            <textarea
              style="background: #efefef29"
              class="form-control"
              cols="100%"
              rows="20"
              v-model="message.messageToSend"
              v-if="message.type === 'sms'"
              :class="
                this.message.messageToSend.length > this.messageMaxLength &&
                this.message.type === 'sms'
                  ? 'border-warning'
                  : ''
              "
            ></textarea>
            <p
              class="text-danger text-center fw-bold mt-2"
              v-if="
                this.message.messageToSend?.length > this.messageMaxLength &&
                this.message.type === 'sms'
              "
            >
              <span class="material-icons" style="font-size: 13px">highlight_off</span>&nbsp;
              {{
                __('message_interface.step3.long_message').replace(
                  '{0}',
                  message.messageToSend.length
                )
              }}
            </p>
            <CodeEditor
              v-if="isEmailWrite"
              v-model="message.messageToSend"
              :languages="[['html', 'html']]"
              :language-selector="false"
              :display-language="false"
              :copy-code="false"
              theme="default"
              width="100%"
              height="350px"
              max-height="350px"
            />
          </div>
        </div>
        <div class="col-md-4" v-if="message.type === 'sms'">
          <PhoneComponent :message="message.messageToSend" />
        </div>

        <div
          class="col-md-4 text-center"
          v-if="message.type === 'email'"
          :class="isEmailTemplate ? 'col-md-12' : 'col-md-4'"
        >
          <iframe
            ref="iframe"
            :value="message.messageToSend"
            id="content"
            :srcdoc="message.messageToSend"
            frameborder="0"
            title=""
            width="100%"
            height="550px"
          >
          </iframe>
        </div>
        <div :class="isEmailTemplate ? 'col-md-12' : 'col-md-4'">
          <a
            target="_blank"
            :href="`/messages/templates/${message.selectedMessageModel.id}/edit`"
            v-if="isEditableTemplate"
            class="mt-2"
            >{{ __('message_interface.step3.modify_model') }}</a
          >
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <button type="button" @click="$emit('prev-tab')" class="btn btn-primary" v-if="prevButton">
        {{ __('message_interface.btns.prev') }}
      </button>
      <button
        class="btn btn-primary float-right"
        @click="$emit('next-tab')"
        :disabled="isEmptyMessage"
      >
        {{ __('message_interface.btns.next') }}
      </button>
    </div>
    <div class="clearfix"></div>
  </section>
</template>

<script>
import hljs from 'highlight.js'
import CodeEditor from 'simple-code-editor'
import Multiselect from 'vue-multiselect'
import PhoneComponent from './PhoneComponent.vue'

export default {
  name: 'MessageReview',
  props: {
    message: {
      type: Object,
      required: true
    },
    canChangeTemplate: {
      type: Boolean,
      default: true
    },
    prevButton: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Multiselect,
    CodeEditor,
    PhoneComponent
  },
  data() {
    return {
      messageMaxLength: 150
    }
  },
  computed: {
    isEmailTemplate() {
      return this.message.type === 'email' && this.message.model === 'model'
    },
    isEmailWrite() {
      return this.message.type === 'email' && this.message.model === 'write'
    },
    isEmptyMessage() {
      return this.message.messageToSend === '' || this.message.messageToSend === null
    },
    isEditableTemplate() {
      return this.canChangeTemplate && this.message.model === 'model'
    }
  }
}
</script>
